import { authAPI } from "../api/auth";
import { useLatestQuery } from "../api/useLatestQuery";
import { useSettings } from "../settings/useSettings";

export const useWhoAmI = () => {
  const settings = useSettings();

  const { data: whoAmI, isFetched } = useLatestQuery(["authAPI.whoAmI"], () =>
    authAPI.whoAmI({})
  );

  const whoAmIReady = isFetched;
  let confirmedNotLoggedIn =
    whoAmIReady && !!whoAmI?.ok && !whoAmI.userIdFromIdentityProvider;
  let confirmedLoggedIn =
    whoAmIReady && !!whoAmI?.ok && !!whoAmI.userIdFromIdentityProvider;
  const concernId = whoAmI?.concernId;
  const details = whoAmI?.details;
  const selectedProfileInConcernForThisSession =
    whoAmI?.selectedProfileInConcernForThisSession ?? null;
  const selectedVerifiedProfileInConcernForThisSession =
    whoAmI?.selectedVerifiedProfileInConcernForThisSession ?? null;
  const selectedUnverifiedProfileInConcernForThisSession =
    whoAmI?.selectedUnverifiedProfileInConcernForThisSession ?? null;

  if (concernId && window.cvpIdConcern !== concernId) {
    throw new Error("concernId mismatch");
  }

  const isProduction = whoAmI!.environment!.toLowerCase() === "production";

  let confirmedNoVerifiedProfileInConcern =
    whoAmIReady && !!whoAmI?.ok && !!whoAmI.concernId && !whoAmI.hasVerifiedProfileInConcern;

  let confirmedHasVerifiedProfileInConcern =
    whoAmIReady &&
    !!whoAmI?.ok &&
    !!whoAmI.userIdFromIdentityProvider &&
    !!whoAmI.concernId &&
    !!whoAmI.hasVerifiedProfileInConcern;

  if (settings.iframe_loginOldPortal) {
    confirmedNoVerifiedProfileInConcern = true;
    confirmedHasVerifiedProfileInConcern = false;
    confirmedNotLoggedIn = true;
    confirmedLoggedIn = false;
  }

  return {
    whoAmI: whoAmI!,
    isFetched,
    concernId,
    details,
    selectedProfileInConcernForThisSession,
    selectedVerifiedProfileInConcernForThisSession,
    selectedUnverifiedProfileInConcernForThisSession,
    /** Api call is done, and we know we are logged in */
    confirmedLoggedIn,

    /** Api call is done, and we know we are not logged in */
    confirmedNotLoggedIn,

    /**
     * Api call is done, we have a concern, and preciely one of these two are true:
     * 1. User is not logged in
     * 2. User is logged in, but has no profile in the concern
     */
    confirmedNoVerifiedProfileInConcern,

    /** Api call is done, user is logged in, we have a concern and the user has a profile in that concern */
    confirmedHasVerifiedProfileInConcern,
    isProduction,
  };
};
